import { router } from 'expo-router';
import { StyleSheet, View } from 'react-native';

import { routes } from '@fhs-legacy/frontend/src/utils/routing';

import { tokens } from '../../tokens';
import { Button } from '../button';
import { IconRedeem } from '../icon';
import { XStack, YStack } from '../stack';
import { Text } from '../text';

export const AddGiftCardBanner = () => (
  <XStack style={styles.container}>
    <View style={styles.iconContainer}>
      <IconRedeem size={24} />
    </View>
    <YStack style={styles.content}>
      <Text weight="semibold">Have a Gift Card?</Text>
      <Text style={styles.subtitle}>Add it to the app</Text>
    </YStack>
    <Button onPress={() => router.navigate(routes.giftCards)}>
      <Button.Text>Add Now</Button.Text>
    </Button>
  </XStack>
);

const styles = StyleSheet.create({
  container: {
    padding: 16,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: tokens.colors.$blackOpacity10,
    justifyContent: 'space-between',
    gap: 12,
  },
  iconContainer: {
    backgroundColor: tokens.colors.$blackOpacity04,
    height: 40,
    width: 40,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 40,
  },
  content: {
    justifyContent: 'center',
    alignItems: 'flex-start',
    flex: 1,
  },
  subtitle: {
    fontSize: 12,
    lineHeight: 19.6,
  },
});
